import type React from 'react';

import type {AvatarSize} from '@gravity-ui/uikit';

import type {Account, LoginHistoryEntry, Organization, User} from './models';

export interface UserMenuAction {
    key: string;
    label: string;
    href?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export interface UserMenuGeneralProps {
    user?: User;
    accounts?: Account[];
    loginHistory?: LoginHistoryEntry[];
    organizations?: Organization[];
    currentOrgId?: string;
    actions?: UserMenuAction[];
    hideLoginButton?: boolean;

    internal?: boolean;
    /**
     * @deprecated This prop will be removed in the next major
     */
    oauthUrl?: string;
    baseUrl?: string;
    logoutUrl?: string;

    onSelectOrganization?: (organization: Organization) => void;
    onDeleteHistoryEntry?: (entryId: string) => void;
    onOpenUserInfo?: () => void;
    onEvent?: (event: UserMenuEvent) => void;

    popupClassName?: string;
}

export interface UserMenuDefaultProps {
    compact: boolean;
    size: AvatarSize;
    showUserInfo: boolean;
    cloudAuth: boolean;
    /**
     * @deprecated This prop will be removed in the next major
     */
    showSsoLogin: boolean;
}

export interface UserMenuProps extends UserMenuGeneralProps, Partial<UserMenuDefaultProps> {}

export enum UserDropdownEventType {
    CurrentUserLogout = 'currentUserLogout',
    SwitchUser = 'switchUser',
    AccountLogin = 'accountLogin',
    AccountLogout = 'accountLogout',
}

type CurrentUserLogoutEvent = {
    type: 'currentUserLogout';
};

type SwitchUserEvent = {
    type: 'switchUser';
    payload: {
        account: Account;
        currentUser: User;
    };
};

type LogoutAccountEvent = {
    type: 'accountLogout';
    payload: {
        account: Account;
        currentUser: User;
    };
};

export type UserMenuEvent = CurrentUserLogoutEvent | SwitchUserEvent | LogoutAccountEvent;
